// extracted by mini-css-extract-plugin
export default {"root":"Customer_root__kqi1L","row":"Customer_row__YK0K9"};